import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import { useScroll } from "motion/react";
import { useRef } from "react";
import { SectionHeader } from "./SectionHeader";
import Divider from "../Divider";
import { TimelineItem } from "../EducationTimeline/TimelineItem";

const logos = {
  imda: "https://upload.wikimedia.org/wikipedia/en/5/5a/Infocomm_Media_Development_Authority_logo.svg",
  sp: "https://upload.wikimedia.org/wikipedia/commons/f/ff/Singapore_Polytechnic_logo.png",
  moe: "https://www.scholaro.com/db/Images/Resources/Singapore.jpg",
  govtech: "https://isomer-user-content.by.gov.sg/85/06d6b95f-fc6b-418d-8b08-9efa88790822/GovTech%20Inline%20Logo_V3_no%20bg.gif",
};

const education = [
  {
    school: "University",
    study: "Bachelor of Computing in Computer Science",
    period: {
      start: 2027,
      end: 2031,
    },
    upcoming: true,
    awards: [
      {
        name: "Smart Nation Scholarship (GovTech)",
        description: "A competitive public-service scholarship for those passionate about tech.",
        years: ["2024 - 2035"],
        highlight: true,
        icon: logos.govtech,
      },
    ],
  },
  {
    school: "Singapore Polytechnic",
    study: "Diploma in Information Technology",
    period: {
      start: 2021,
      end: 2024,
    },
    merit: true,
    awards: [
      {
        name: "Singapore Digital (SG:D) Scholarship",
        description: "A government scholarship awarded by IMDA to support students pursuing studies in digital and technology-related fields.",
        years: ["2021", "2022", "2023", "2024"],
        highlight: true,
        icon: logos.imda,
      },
      {
        name: "Symrise Prize",
        description: "Awarded for graduating 9th in cohort.",
        years: ["2024"],
        icon: logos.sp,
      },
      {
        name: "Diploma with Merit",
        description: "Graduated with a Diploma with Merit in Information Technology for graduating within the 10% of the cohort.",
        years: ["2024"],
        icon: logos.sp,
      },
      {
        name: "Director's Honour Roll (Dean's List)",
        description: "Recognises outstanding academic excellence by placing among the top 10% within the cohort in the academic year.",
        years: ["AY2021/2022", "AY2022/2023"],
        icon: logos.sp,
      },
      {
        name: "Edusave Certificate of Academic Achievement",
        description: "Certificate award for strong academic performance and placing within the top 25% of the cohort during the academic year.",
        years: ["AY2021/2022", "AY2022/2023"],
        icon: logos.moe,
      },
      {
        name: "Edusave Skills Award",
        description:
          "Recognises up to 5% of students who demonstrate strong practical skills, leadership, and contributions beyond academic results.",
        years: ["AY2023/2024"],
        icon: logos.moe,
      },
      {
        name: "Edusave Merit Bursary Award",
        description: "Monetary award for strong academic performance and placing within the top 25% of the cohort during the academic year.",
        years: ["AY2021/2022", "AY2022/2023", "AY2023/2024"],
        icon: logos.moe,
      },
    ],
  },
  {
    school: "Secondary School",
    study: "GCE 'O' Levels",
    period: {
      start: 2017,
      end: 2020,
    },
    awards: [
      {
        name: "Edusave Award for Achievement, Good Leadership and Service (EAGLES)",
        description:
          "Recognises up to 15% of students who demonstrate good conduct, leadership, service, excellence in non-academic areas, and 21st century competencies in a cosistent and exemplary manner.",
        years: ["2020"],
        icon: logos.moe,
      },
    ],
  },
];

export default function EducationAwardsSection() {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({ target: container, offset: ["start start", "end end"] }); // Progress starts when the section has completely filled the viewport

  return (
    <ScrollAnimContext.Provider value={scrollYProgress}>
      <div id='education' className={"text-base-content w-full flex flex-col items-center"} ref={container}>
        <div className='xl:w-4/5 2xl:w-7/10 4xl:w-3/5 py-24 lg:py-48 px-6 md:px-12'>
          {/* Education & Awards Section */}
          <div>
            <SectionHeader heading='Education & Awards' />
            <Divider className='border border-gray-300 my-8 sm:my-12 lg:my-16' />
            <div className='flex pl-4 sm:pl-32 sm:px-16 2xl:pl-8'>
              <div className='pl-8 pr-4 grow relative lg:ml-8'>
                {/* Timeline Line */}
                <div className='absolute h-full w-1 bg-neutral-500 rounded-full left-0' />
                <div className='flex flex-col gap-16 py-8'>
                  {/* Timeline Items */}
                  {education.map((edu, index) => (
                    <TimelineItem
                      key={index}
                      school={edu.school}
                      study={edu.study}
                      period={edu.period}
                      merit={edu.merit}
                      awards={edu.awards}
                      upcoming={edu.upcoming}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScrollAnimContext.Provider>
  );
}
